<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Gerki</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezoneBranje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            /> 
            
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
     <div class="columnBar">
              <kendo-multiselect
                        :data-source="columns"
                        :data-text-field="'title'"
                        :data-value-field="'field'"
                        :placeholder="'Skrij stolpce'"
                         @select="skrijStolpec"
                        @deselect="prikaziStolpec"
                        :filter="'contains'"
                        :auto-width="true"
                        :value="hiddenColumns"
                        >
            </kendo-multiselect>
        </div>
          <div class="grid-wrapper">
    <Grid  
                       auto-bind=false
                        :sortable="sortable"
                        :filterable="filterable"
                        :detail="'gerkDetailRowTemplate'"
                          :pageable="{ buttonCount: 4, pageSizes: [10,50,100,'all'] }"
                        :data-items="dataResult"
                        :skip="skip"
                        :take="take" 
                        :sort="sort" 
                        :resizable="true"
                      
                        :filter="filter" 
                        :columns="columns"
                        @datastatechange="dataStateChange"

                        :expand-field="'expanded'"
                        @expandchange="expandChange"
                        @pagechange="pageChangeHandler"
                      
                        
                      
                        

                         
                        
                                               >
                        <template v-slot:gerkDetailRowTemplate="{props}">
                        <gerkDetailRow :data-item="props.dataItem" :sezona="dataSezona" />
                        </template>
                        
                         <template v-slot:gerkViewLink="{props}">
                        <gerkViewLink :data-item="props.dataItem"/>
                        </template>

                        <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                             <button 
                                title="Išči"
                                class="k-button k-primary"
                                @click="naloziPodatke"
                            >
                                Išči
                            </button>
                        <button
                                title="Izvozi v Excel"
                                class="k-button k-primary"
                                @click="exportExcel"
                            >
                                Izvozi v Excel
                            </button>
                        </div>
                            
                        </toolbar>
                    </Grid>
                     <div class="shema-loader" v-if="loading"><font-awesome-icon icon="circle-notch" spin="spin"/></div>
                    </div>
                    </div>
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';

import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';

import kulture from './support/kulture-data';
import { Grid, GridToolbar,GridNoRecords } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
//import { saveExcel } from '@progress/kendo-vue-excel-export';
import { MultiSelect } from '@progress/kendo-dropdowns-vue-wrapper';
import { process } from '@progress/kendo-data-query';
import GerkViewLink from './support/GerkViewLink';
import GerkDetailRow from './support/GerkDetailRow';








export default {
  props:['sezona','pridelovalecid'],
   components:{
      'dropdownlist': DropDownList,
   
      'kendo-multiselect': MultiSelect,
      'gerkViewLink': GerkViewLink,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'gerkDetailRow':GerkDetailRow,
      'toolbar': GridToolbar,
 
  },
    data () {
        return {
       
            dataSezona:this.sezona,
            loading:false,
            girdDataApi:null,
            gridData:null,


            filter: null,
            editID: null,
            skip: 0,
            take: 10,
            pageSize: 10,
            sortable: true,
            filterable: true,
            groupable: false,
            
            expandedItems: [],
            dataResult: [],
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' }
            ],
            columns: [
           
             
                { field: "kmgmid", title:"KMG-MID",width: "210",footerCell: this.nogaStMidov},
                { field: "kontrolnastevilka", title:"Kontrolna št.",width: "150px",hidden:true},
                { field: "imenosilca", title:"Nosilec",width: "150px",hidden:true},
                { field: "statuspridelovalca", title:"Status KMG-MID",width: "150px",hidden:true},
                { field: "gerkpid", title:"GERKPID", footerCell: this.nogaStGerkov,width: "150px"},
                { field: "rabaid", title:"Šifra rabe",type: "string"},
                { field: "raba", title:"Raba",type: "string"},
                { field: "povrsina", title:"Površina",type: "number",format:"{0:n4}", footerCell: this.nogaVsotaPovrsin}, //footer:this.vsotaPovrsin,
                { field: "status", title:"Status",type:"string",width: "80px"},
                { field: "statuszasubvencijo", title:"Status za subvencijo",type:"string",width: "150px"},
                { field: "razlogspremembe", title:"Razlog spremembe",type: "string"},
                { field: "gerkpid", title:"Ogled",filterable:false, cell:'gerkViewLink',width: "50px", webonly:true},
            ],
          

           

        }
    },
    created () {

if(this.userDetails.pravice.includes("STATISTIKA_BERI"))
                this.columns.push({ field: "kontrolnaorganizacija", title:"V kontroli pri"});
            

      this.dataSezona={sezona:this.sezona};
      if(!this.sezona)
      this.dataSezona={sezona:Math.max(...this.sezoneBranje.map(s=>s.sezona))};
     //
     
    
    },
    computed: {
  hiddenColumns() {
            return this.columns.filter(c=>c.hidden);
        },
        ...mapState('gerk', ['gerk']),
        ...mapState('pridelava', ['pridelovalec']) , 
         ...mapState('users', ['userDetails','sezoneBranje']),         
    
           },
      watch: {
        skip(newValue, oldValue){
   
            const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gerk, dataState);
        },
        take(newValue, oldValue){
            
            const dataState = {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                group: this.group
            }
        this.dataResult = process( this.gerk, dataState);
        },
       gerk(newValue, oldValue) {
   

      if(newValue){
       const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gerk, dataState);

        }
    }
},
    methods: {

        ...mapActions('gerk', ['loadVse','save']),
        ...mapActions('pridelava', ['loadOne']),
        naloziPodatke: async function(e){
            this.loading=true;
            if(!this.sezona){
                this.dataSezona={sezona:Math.max(...this.sezoneBranje.map(s=>s.sezona))};
                this.sezona=this.dataSezona.sezona;
            }
            else
                this.dataSezona={sezona:this.sezona};
        this.loadVse(this.dataSezona).then(()=>this.loading=false);
        },

        skrijStolpec: function(e) {
            let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=true;
                const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gerk, dataState);
           
        },
        prikaziStolpec: function(e) {
           let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=false;
                const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gerk, dataState);
        },
        vsotaPovrsin(a,b){
            return kendo.toString(this.dataResult?.data?.reduce((acc, current) => acc+=current.povrsina, 0),"n4")+ ' ha';
        },
        nogaStGerkov: function (h, emptyElement , props, listeners ) {
          if(this.gerk)
            return h('span', {}, ['Število gerkov: ' + (this.dataResult?.data?.length?this.dataResult?.data?.length:'0')]);
        },
        nogaVsotaPovrsin: function (h, emptyElement , props, listeners ) {
          if(this.gerk)
            return h('span', {}, ['Vsota površin: ' + kendo.toString(this.dataResult?.data?.reduce((acc, current) => acc+=current.povrsina, 0),"n4")+ ' ha']);
        },
     nogaStMidov: function (h, emptyElement , props, listeners ) {
          if(this.dataResult.data){
            var counts = {};
                for (var i = 0; i < this.dataResult.data.length; i++) {
                    counts[this.dataResult.data[i][props.field]] = 1 + (counts[this.dataResult.data[i][props.field]] || 0);
                }
                 return h('span', {}, ['Število MID-ov: '+kendo.toString(Object.keys(counts).length,"n0")]);
            }
           
        },
       sezonaChange(event) {
              const sezona = event.value;
            this.$router.push({ name: 'vsiGerki', params: { sezona:sezona.sezona} })
            this.dataSezona=sezona;
            //this.loadVse(this.dataSezona);



        },

        
        createAppState: function(dataState) {
          
            this.take = dataState.take;
            this.skip = dataState.skip?dataState.skip:0;
            if (dataState.group) {
                dataState.group.map(group => group.aggregates = this.aggregates);
            }
            this.group = dataState.group;
            this.filter = dataState.filter;
            this.sort = dataState.sort;
           
        },

        dataStateChange (event) {
            this.createAppState(event.data);
            this.dataResult = process(this.gerk, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });
          

        },
        expandChange (event) {
          
             Vue.set(event.dataItem, event.target.$props.expandField, !event.dataItem.expanded);
            console.log(event);
        },
        exportExcel () {
            this.loading=true;
            var thisApp=this;
            this.saveExcel({
                data: process(this.gridData, {sort: this.sort,filter: this.filter}).data,
                fileName: this.dataSezona.sezona+"_GERKI",
                columns: this.columns.filter(i=>!i.hidden&&!i.webonly),
                onExportComplete:function(){thisApp.loading=false;}

            })
            
        },
         pageChangeHandler: function(event) {
            console.log(event);
            this.skip = event.page.skip;
            this.take = event.page.take;
           
        }
        
    }
};
</script>

